export * from './product-one-component-config.interface';
